module.exports = __webpack_public_path__ + "img/storage_title.228d094d.svg";